import {
  PACKAGE_OMS_COMMAND_PENDING,
  PACKAGE_OMS_COMMAND_REJECTED,
  PACKAGE_OMS_COMMAND_FULFILLED,
  CLEAR_PACKAGE_OMS_COMMAND
} from "../constants/packageOmsCommand";
import { isRequestSuccessful } from "../theme/utils";

const initialState = {
  pending: false,
  omsCommandResponse: {},
  success: false,
  error: {}
};

export const omsCommand = (state = initialState, action) => {
  switch (action.type) {
    case PACKAGE_OMS_COMMAND_PENDING:
      return { ...state, pending: true, error: {} };

    case PACKAGE_OMS_COMMAND_REJECTED:
      return {
        ...state,
        pending: false,
        error: action.error
      };

    case PACKAGE_OMS_COMMAND_FULFILLED:
      return {
        ...state,
        omsCommandResponse: action.response.data,
        success: isRequestSuccessful(action.response.status),
        pending: false,
        error: {}
      };

    case CLEAR_PACKAGE_OMS_COMMAND:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/packageOmsCommand.js